import React from "react";

export const Change: React.FunctionComponent = () => (
	<section>
		<h1>Vesetranszplantációs Várólista Fórum - Értékelőlap.</h1>
		<p>Kedves Regisztrált Résztvevőnk!</p>
		<p>
			A 2025.09.19-én megrendezésre került fórumon 60 regisztrált kolléga
			volt jelen. Köszönjük mindenkinek az aktív részvételt! Bízunk benne,
			hogy hasznos volt a szakmai program és ugyancsak hasznos
			beszélgetések alakultak a kávészünetekben.
		</p>
		<p>
			Kérjük, értékeljék a rendezvényt az alábbi, gyors (1 perc) kérdőív
			kitöltésével:
		</p>
		<p>
			<a
				href="https://forms.gle/QdP21Qv3nwQp7Rhq6"
				target="_blank"
				rel="noopener noreferrer"
			>
				https://forms.gle/QdP21Qv3nwQp7Rhq6
			</a>
		</p>
		<p>Köszönettel kívánunk további jó munkát!</p>
		<p>
			Szervezők nevében: <br />
			Dr. Cseprekál Orsolya
		</p>
	</section>
);
